import { render, staticRenderFns } from "./chat-reactions.vue?vue&type=template&id=201480de&scoped=true&lang=pug"
import script from "./chat-reactions.vue?vue&type=script&lang=js"
export * from "./chat-reactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201480de",
  null
  
)

export default component.exports